import { useFirmContext } from '../../../../../providers/FirmProvider';
import FYILogo from '../../../../../assets/fyi.png';
import IntegrationOverview from '../../../../../components/integration-overview/IntegrationOverview';
import FirmFYIIntegration from './FirmFYIIntegration';

type FirmFYIIntegrationOverviewProps = {
    show: boolean;
};

function FirmFYIIntegrationOverview({ show }: FirmFYIIntegrationOverviewProps): JSX.Element | null {
    const {
        integrations: { fyi },
    } = useFirmContext();

    if (!show) {
        return null;
    }

    return (
        <IntegrationOverview
            title="FYI"
            logo={FYILogo}
            active={Boolean(fyi?.cabinet)}
            description="Connect FYI to Cimplico Workpapers to streamline your file referencing process. The integration also provides for seamless onboarding of entities, groups, and users."
        >
            <FirmFYIIntegration />
        </IntegrationOverview>
    );
}

export default FirmFYIIntegrationOverview;
